import React, { createContext, useState, useContext } from 'react';

const BackgroundContext = createContext();

export const useBackground = () => useContext(BackgroundContext);

export const BackgroundProvider = ({ children }) => {
  const [backgroundImage, setBackgroundImage] = useState(''); // Default or initial background

  const changeBackground = (newImageUrl) => {
    setBackgroundImage(newImageUrl);
  };

  return (
    <BackgroundContext.Provider value={{ backgroundImage, changeBackground }}>
      {children}
    </BackgroundContext.Provider>
  );
};